import DataTable from 'datatables.net-bs5';

// ── Twin-select on-change navigation (D-02) ─────────────────────────────────
// Mirrors src/js/eo/items.ts:342-356 (Phase 85 twin-select pattern).
// Choices.js auto-enhancement (via shared.ts:14 init_choices) still fires
// native `change` on the underlying <select> — verified by eo/items.ts:349.

function wireTwinSelect(): void {
    const a = document.querySelector('.js-toolbox-compare-a') as HTMLSelectElement | null;
    const b = document.querySelector('.js-toolbox-compare-b') as HTMLSelectElement | null;
    if (!a || !b) return;

    const onChange = (): void => {
        const aId = a.value || '0';
        const bId = b.value || '0';
        window.location.href = '/toolbox/benchmarks/compare/' + aId + '/' + bId;
    };

    a.addEventListener('change', onChange);
    b.addEventListener('change', onChange);
}

// ── Six DataTables init (D-03 Δ DESC default sort) ──────────────────────────

function initTables(): void {
    const tables = document.querySelectorAll('table[data-table^="compare-"]');
    if (tables.length === 0) return;
    tables.forEach((el) => {
        new DataTable(el as HTMLTableElement, {
            pageLength: 25,
            order: [[3, 'desc']],   // Δ column DESC → worst regression at top
        });
    });
}

// ── Module export ───────────────────────────────────────────────────────────

export default class {
    static init = (): void => {
        const sel = document.querySelector('.js-toolbox-compare-a');
        if (!sel) return;   // not on compare page — no-op
        wireTwinSelect();
        initTables();
    };
}
